import { erroDeVerificacao, MENSAGEM_VERIFICACAO } from "./appCheck";

export function mensagemErroCliente(error) {
  const code = error?.code || "";
  if (erroDeVerificacao(error)) return MENSAGEM_VERIFICACAO;
  if (["auth/invalid-credential","auth/invalid-login-credentials","auth/wrong-password","auth/user-not-found"].includes(code)) return "Email ou senha incorretos. Confira os dados ou recupere sua senha.";
  const messages = {
    "auth/invalid-email":"Confira o formato do email.",
    "auth/email-already-in-use":"Este email já tem uma conta. Entre com sua senha ou use a recuperação.",
    "auth/weak-password":"A senha precisa ter no mínimo 8 caracteres, com letra maiúscula, número e símbolo.",
    "auth/too-many-requests":"Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.",
    "auth/network-request-failed":"Não foi possível conectar. Confira sua internet e tente novamente.",
    "auth/user-disabled":"Esta conta está desativada. Entre em contato com a loja.",
    "auth/operation-not-allowed":"Esta forma de entrada ainda não está disponível. Entre em contato com a loja.",
    "auth/unauthorized-domain":"Este endereço ainda não está autorizado para entrar com Google. Use email e senha ou avise a loja.",
    "auth/popup-blocked":"Permita a janela de login no navegador e tente novamente.",
    "auth/web-storage-unsupported":"Permita o armazenamento deste site no navegador para manter sua conta conectada.",
    "functions/invalid-argument":"Confira o código e os dados informados.",
    "functions/not-found":"Código inválido ou expirado. Solicite um novo código.",
    "functions/deadline-exceeded":"Código expirado. Solicite um novo código.",
    "functions/resource-exhausted":"Muitas tentativas. Aguarde antes de tentar novamente.",
    "functions/unavailable":"Não foi possível conectar. Confira sua internet e tente novamente.",
  };
  return messages[code] || "Não foi possível entrar agora. Confira sua conexão e tente novamente.";
}
